'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*  weak */
var precedence = {
  ':link': 4,
  ':visited': 3,
  ':hover': 2,
  ':focus': 1.5,
  ':active': 1
};

function sortPseudoClasses(left, right) {
  var precedenceLeft = precedence[left]; // eslint-disable-line
  var precedenceRight = precedence[right];
  // Only sort if both properties are listed
  // This prevents other pseudos from reordering
  if (precedenceLeft && precedenceRight) {
    return precedenceLeft < precedenceRight ? 1 : -1;
  }
  return 0;
}

function LVHA(style) {
  return Object.keys(style).sort(sortPseudoClasses).reduce(function (out, pseudo) {
    out[pseudo] = style[pseudo];
    return out;
  }, {});
}

exports.default = function () {
  return LVHA;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/plugins/LVHA.js
// module id = 477
// module chunks = 0